import React from 'react';
import messages_en from "../en/messages_en.mjs";
import consumer_messages_en from "../en/consumer_messages_en.mjs";

const messages = {
  ...messages_en,
  ...consumer_messages_en
};

const accountTypesBuilderKey = 'currentAccountTypes';
const savingsTypesBuilderKey = 'savingsGoalTypes';
const loanTypesBuilderKey = 'borrowGoalsTypes';
const editCardRender = <i className="fa fa-pencil"/>;
const removeCardRender = <i className="fa fa-times"/>;
const saveCardRender = <>Save <i className="fa fa-caret-right"/></>;

const renderCardLayout = (builderKey, cardKey, imageTitle) => {
  const image = messages[`${builderKey}.${cardKey}.image`];
  const title = messages[`${builderKey}.${cardKey}.title`];
  const cardContent = <>
    <img src={image} alt={imageTitle || cardKey}/>
    <span>{title}</span>
  </>;

  return {
    [`${builderKey}.${cardKey}`]: cardContent
  }
};

export default {
  ...renderCardLayout(accountTypesBuilderKey, 'checking'),
  ...renderCardLayout(accountTypesBuilderKey, 'savings'),
  ...renderCardLayout(accountTypesBuilderKey, 'cd'),
  ...renderCardLayout(accountTypesBuilderKey, 'retirement'),
  [`${accountTypesBuilderKey}.cardBuilder.editCard`]: editCardRender,
  [`${accountTypesBuilderKey}.cardBuilder.removeCard`]: removeCardRender,
  [`${accountTypesBuilderKey}.cardBuilder.saveCard`]: saveCardRender,

  ...renderCardLayout(loanTypesBuilderKey, 'borrowHomeGoal'),
  ...renderCardLayout(loanTypesBuilderKey, 'borrowSecondHomeGoal'),
  ...renderCardLayout(loanTypesBuilderKey, 'borrowVehicleGoal'),
  ...renderCardLayout(loanTypesBuilderKey, 'borrowLandGoal'),
  ...renderCardLayout(loanTypesBuilderKey, 'borrowEducationGoal'),
  ...renderCardLayout(loanTypesBuilderKey, 'borrowHomeImprovementGoal'),
  ...renderCardLayout(loanTypesBuilderKey, 'borrowDebtConsolidationGoal'),
  ...renderCardLayout(loanTypesBuilderKey, 'borrowOtherGoal'),
  [`${loanTypesBuilderKey}.cardBuilder.editCard`]: editCardRender,
  [`${loanTypesBuilderKey}.cardBuilder.removeCard`]: removeCardRender,
  [`${loanTypesBuilderKey}.cardBuilder.saveCard`]: saveCardRender,
  ...renderCardLayout(savingsTypesBuilderKey, 'savingsHolidayGoal'),
  ...renderCardLayout(savingsTypesBuilderKey, 'savingsMajorGoal'),
  ...renderCardLayout(savingsTypesBuilderKey, 'savingsRetirementGoal'),
  ...renderCardLayout(savingsTypesBuilderKey, 'savingsUnexpectedGoal'),
  ...renderCardLayout(savingsTypesBuilderKey, 'savingsOtherGoal'),
  [`${savingsTypesBuilderKey}.cardBuilder.editCard`]: editCardRender,
  [`${savingsTypesBuilderKey}.cardBuilder.removeCard`]: removeCardRender,
  [`${savingsTypesBuilderKey}.cardBuilder.saveCard`]: saveCardRender,

  'overdraftServicesVideo': <>
    Click on link to learn more: <a href="https://www.hancockwhitney.com/hubfs/HW-Products-Services-Videos/Hancock%20Whitney%20Overdraft%20Protection%20Services.mp4" target="_blank">Watch Video</a>
  </>
};
